// Override to handle request params
InteractiveChart.prototype._requestChart = function (oInputs) {
    this._setLoadingState(true);

    // if there is already an XHR request in process cancel it.
    if (this._CHART_XHR) {
        try {
            if (this._CHART_XHR.abort) {
                this._CHART_XHR.abort();
            }
        }
        catch (e) {
            // don't do anything. Sometimes IE browsers have a hard time aborting ajax calls. Sounds like a moral issue to me. OOOOOH
        }
    }
   
    this._CHART_XHR = $.ajax({
        context: this,
        type: "POST",
        url: this.API_DRAW_CHART.resolveUrl(),
        dataType: "json",
        data: { inputData: JSON.stringify(oInputs), params: JSON.stringify(this.REQUESTPARAMS) },
        success: this._handleChartResponse.Context(this),
        //error: this._handlePreScreenResponseError,
        complete: function () { this._setLoadingState(false); } .Context(this)
    });
   
};

InteractiveChart.prototype._setLoadingState = function (bLoading) {
    this._container.parents(".data-module").toggleClass("loading", bLoading);
};

InteractiveChart.prototype.GetSymbolInput = function () {
    return this._inputData.VLTicker;
};

InteractiveChart.prototype.GetBundleInput = function () {
    return this._inputData.BundleId;
};

InteractiveChart.prototype.GetProductInput = function () {
    return this._inputData.ProductName;
};